import React, { FunctionComponent } from 'react';
import { II18n } from '../../../models';
import { BrassIcon } from '../icon/Icon';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { BrassButtonSharedPropsV1, BrassButtonSharedV1 } from './ButtonV1';

const BrassButtonDeleteV1: FunctionComponent<BrassButtonSharedPropsV1> = (
  props: BrassButtonSharedPropsV1,
) => (
  <BrassButtonSharedV1
    themeColor='primary'
    className='brass-button-delete'
    labelKey='delete'
    tooltipKey='clickToDelete'
    translations={translations}
    icon={<BrassIcon icon={faTrashAlt} size='lg' />}
    {...props}
  />
);

const translations: II18n = {
  es: {
    delete: 'Eliminar',
    clickToDelete: 'Haga clic para eliminar',
  },
  enUS: {
    delete: 'Delete',
    clickToDelete: 'Click to delete',
  },
  ptBR: {
    delete: 'Excluir',
    clickToDelete: 'Clique para excluir',
  },
};

export { BrassButtonDeleteV1 };
